// TEXT input for "ProductCategory"
const Input = {
    // General Information
    name: {
      category:'Clothing',
    },
  
    // Sort Filter
    sortOptions: [
        { name: 'Most Popular', href: 'https://www.google.com/', current: true },
        { name: 'Best Rating', href: 'https://www.google.com/', current: false },
        { name: 'Newest', href: 'https://www.google.com/', current: false },
        { name: 'Price: Low to High', href: 'https://www.google.com/', current: false },
        { name: 'Price: High to Low', href: 'https://www.google.com/', current: false },
    ],
  
    // Category Filter
    subCategories: [
        { name: 'Tops', href:'/luna-demo/men/clothing/tops'},
    ],
  
    // Specific Category Filters
    filters: [
      {
        id: 'category',
        name: 'Category',
        options: [
          { value: 'new-arrivals', label: 'New Arrivals', checked: false },
          { value: 'sale', label: 'Sale', checked: false },
          { value: 'travel', label: 'Travel', checked: false },
          { value: 'organization', label: 'Organization', checked: false },
          { value: 'accessories', label: 'Accessories', checked: false },
        ],
      },    
      {
        id: 'color',
        name: 'Color',
        options: [
          { value: 'white', label: 'White', checked: false },
          { value: 'beige', label: 'Beige', checked: false },
          { value: 'blue', label: 'Blue', checked: false },
          { value: 'brown', label: 'Brown', checked: false },
          { value: 'green', label: 'Green', checked: false },
          { value: 'purple', label: 'Purple', checked: false },
        ],
      },
      {
        id: 'size',
        name: 'Size',
        options: [
          { value: '2l', label: '2L', checked: false },
          { value: '6l', label: '6L', checked: false },
          { value: '12l', label: '12L', checked: false },
          { value: '18l', label: '18L', checked: false },
          { value: '20l', label: '20L', checked: false },
          { value: '40l', label: '40L', checked: false },
        ],
      },
    ],
  
    // Product Listing
    products: [
      {
        id: 1,
        name: 'Nike Air Max Furyosa',
        category: "Nike Footwear",
        href: './nike-air-max',
        price: '$99',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/nike.png',
        imageAlt: 'image 1',
      },
      {
        id: 2,
        name: 'Adidas Originals Retropy F2 Sneaker Mens',
        category: "Adidas Footwear",
        href: './adidas-originals-retropy',
        price: '$89',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/adidas.png',
        imageAlt: 'image 2',
      },
      {
        id: 3,
        name: "New Balance 327 Moonbeam 'New Spruce'",
        category: "New Balance Footwear",
        href: './new-balance-327',
        price: '$119',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/nb.png',
        imageAlt: 'image 3',
      },
    ]
  }
  
  export default Input;